import React from 'react';
import Button from '../button/button';
import UploadStatusMessage from './uploadStatusMessage';
export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName('control-upload-button') + ' ' + (this.isStatusNone() ? 'no-bottom-message' : ''),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-confirm-secondary",
    onClick: this.isDisabled() ? null : this.props.onClick,
    disabled: this.isDisabled()
  }, this.getButtonContent()), /*#__PURE__*/React.createElement(UploadStatusMessage, {
    value: this.props.value,
    status: this.props.status,
    processMessage: this.props.processMessage,
    errorMessage: this.props.errorMessage
  }));
}